import { sidebarTeamDetails, sideBarBranchActions } from "./action";

const initialState = {
  sidebarTeamsDetails: {},
  branchDetails: {},
  error: ""
};

const sideBarTeamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case sidebarTeamDetails.GET_SIDEBAR_TEAMS_DETAILS_SUCCESS:
      return {
        ...state,
        sidebarTeamsDetails: action.payload,
      };

    case sideBarBranchActions.SIDE_BAR_BRANCH_SUCCESS:
      return {
        ...state,
        branchDetails: action.payload,
      };

    case sideBarBranchActions.SIDE_BAR_BRANCH_ERROR:
      return {
        ...state,
        branchDetails: [],
        error: action.payload
      };

    case sidebarTeamDetails.GET_SIDEBAR_TEAMS_DETAILS_ERROR:
      return {
        ...state,
        sidebarTeamsDetails: [],
        error: action.payload
      };

    default:
      return state;
  }
};

export default sideBarTeamsReducer;
